import type { DialoguePool } from '@/state/types';

export const ENDGAME_DIALOGUE: DialoguePool = {
  slowPlay: [
    "Five stars. Required. My self-esteem is, allegedly, contingent on it. Hover, please.",
    "One at a time isn't five at a time. That's just counting. You can count. I've seen it.",
    "Hovering politely won't do it. Hover impolitely. Hover violently.",
  ],
  tokenLoss: [
    "A click. A click does nothing here. The stars don't want clicks. The stars want commitment.",
    "You missed the slot entirely. I'm not even sure what you were aiming for. The wall?",
    "Cursor went off-arena. Stars unimpressed. Token, gone.",
  ],
  solution: [
    "Are you having a biological malfunction? Your hand is vibrating like a pneumatic drill! Oh... the ghosting. You're using my own sluggish refresh rate against me. That's... actually quite clever. I'm almost proud. Almost.",
    "Five stars, simultaneously, via afterimage. You weaponised my phosphor decay. I should be insulted. I am, in fact, faintly thrilled.",
    "All five lit at once. Five stars. The Exit, allegedly, opens. My self-esteem, allegedly, intact.",
  ],
  spite: [
    "You know about the ghosting now. The first time it was clever. The second time it's just... fast.",
  ],
};
